import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {ResearchKeywordCreateDTO, ResearchKeywordDTO} from '../../dto/research-keywords';

@Injectable({
  providedIn: 'root',
})
export class ResearchKeywordService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/project';

  getKeywords(projectId: number): Observable<ResearchKeywordDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.get<ResearchKeywordDTO[]>(`${this.apiUrl}/${projectId}/research/keywords`);
  }

  getSynonyms(projectId: number, keyword: string): Observable<string[]> {
    if (!keyword) {
      throw new Error('keyword is required');
    }
    return this.http.get<string[]>(`${this.apiUrl}/${projectId}/research/keywords/synonyms/${keyword}`);
  }

  getKeywordById(projectId: number, id: number): Observable<ResearchKeywordDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.get<ResearchKeywordDTO>(`${this.apiUrl}/${projectId}/research/keywords/${id}`);
  }

  generateKeywords(projectId: number): Observable<ResearchKeywordDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.post<ResearchKeywordDTO[]>(`${this.apiUrl}/${projectId}/research/keywords/generate`, {});
  }

  createKeyword(projectId: number, dto: ResearchKeywordCreateDTO, updateLinkedQueries: boolean = true): Observable<ResearchKeywordDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.post<ResearchKeywordDTO>(`${this.apiUrl}/${projectId}/research/keywords?updateLinkedQueries=${updateLinkedQueries}`, dto);
  }


  updateKeyword(projectId: number, id: number, keyword: ResearchKeywordDTO, updateLinkedQueries: boolean = true): Observable<ResearchKeywordDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.put<ResearchKeywordDTO>(`${this.apiUrl}/${projectId}/research/keywords/${id}?updateLinkedQueries=${updateLinkedQueries}`, keyword);
  }

  deleteKeyword(projectId: number, id: number, updateLinkedQueries: boolean = true): Observable<HttpResponse<string>> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.delete(`${this.apiUrl}/${projectId}/research/keywords/${id}?updateLinkedQueries=${updateLinkedQueries}`, {
      observe: 'response',
      responseType: 'text'
    });
  }

}
